export const getMusicDiscographyReviewRoute = (albumId = null) => '/discography/' + (albumId ?? ':albumId') + '/review';
export const getMusicDiscographyEditRoute = (releaseId = null) => '/discography/' + (releaseId ?? ':releaseId');
export const getMusicDiscographyRoute = () => '/discography';
